export const CLEAR_STATE = '@@refill/CLEAR_STATE';

export const GET_LIST = '@@refill/GET_LIST';
export const GET_LIST_SUCCESS = '@@refill/GET_LIST_SUCCESS';
export const GET_LIST_ERROR = '@@refill/GET_LIST_ERROR';

export const GET_CONFIG = '@@refill/GET_CONFIG';
export const GET_CONFIG_SUCCESS = '@@refill/GET_CONFIG_SUCCESS';
export const GET_CONFIG_ERROR = '@@refill/GET_CONFIG_ERROR';

export const GET_MODES = '@@refill/GET_MODES';
export const GET_MODES_SUCCESS = '@@refill/GET_MODES_SUCCESS';
export const GET_MODES_ERROR = '@@refill/GET_MODES_ERROR';

export const GET_SERVICES = '@@refill/GET_SERVICES';
export const GET_SERVICES_SUCCESS = '@@refill/GET_SERVICES_SUCCESS';
export const GET_SERVICES_ERROR = '@@refill/GET_SERVICES_ERROR';

export const VIEW_TASK = '@@refill/VIEW_TASK';
export const VIEW_TASK_SUCCESS = '@@refill/VIEW_TASK_SUCCESS';
export const VIEW_TASK_ERROR = '@@refill/VIEW_TASK_ERROR';

export const DETAILS_SUPER_REFILL = '@@refill/DETAILS_SUPER_REFILL';
export const DETAILS_SUPER_SUCCESS = '@@refill/DETAILS_SUPER_SUCCESS';
export const DETAILS_SUPER_ERROR = '@@refill/DETAILS_SUPER_ERROR';

export const RESEND_TASK = '@@refill/RESEND_TASK';
export const RESEND_TASK_SUCCESS = '@@refill/RESEND_TASK_SUCCESS';
export const RESEND_TASK_ERROR = '@@refill/RESEND_TASK_ERROR';

export const CANCEL_TASK = '@@refill/CANCEL_TASK';
export const CANCEL_TASK_SUCCESS = '@@refill/CANCEL_TASK_SUCCESS';
export const CANCEL_TASK_ERROR = '@@refill/CANCEL_TASK_ERROR';

export const CHANGE_TASK_STATUS = '@@refill/CHANGE_TASK_STATUS';
export const CHANGE_TASK_STATUS_SUCCESS = '@@refill/CHANGE_TASK_STATUS_SUCCESS';
export const CHANGE_TASK_STATUS_ERROR = '@@refill/CHANGE_TASK_STATUS_ERROR';

export const BULK_UPDATE_STATUS_REFILL = '@@refill/BULK_UPDATE_STATUS_REFILL';
export const BULK_UPDATE_STATUS_SUCCESS = '@@refill/BULK_UPDATE_STATUS_SUCCESS';
export const BULK_UPDATE_STATUS_ERROR = '@@refill/BULK_UPDATE_STATUS_ERROR';

export const BULK_RESEND_TASKS = '@@refill/BULK_RESEND_TASKS';
export const BULK_RESEND_TASKS_SUCCESS = '@@refill/BULK_RESEND_TASKS_SUCCESS';
export const BULK_RESEND_TASKS_ERROR = '@@refill/BULK_RESEND_TASKS_ERROR';

export const BULK_CANCEL_TASKS = '@@refill/BULK_CANCEL_TASKS';
export const BULK_CANCEL_TASKS_SUCCESS = '@@refill/BULK_CANCEL_TASKS_SUCCESS';
export const BULK_CANCEL_TASKS_ERROR = '@@refill/BULK_CANCEL_TASKS_ERROR';
